// src/components/shared/LockGuard/LockGuard.jsx
import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation, Outlet } from "react-router-dom";
import { selectIsExitLocked } from "../../../redux/slices/exitFlowSlice";
import { targetForState } from "../ExitRouteGuard/ExitRouteGuard";
// Block only gameplay routes (adjust as needed)
const GAMEPLAY_PATH_REGEX =
  /^\/(map|SecretsoftheCircuit|accessDenied|digitalBreadcrumbs|visualDecipher|missionAccomplishments|clueboard|settings|missionComplete|missionFailed|finals)/;

export default function LockGuard() {
  const location = useLocation();
  const exitState = useSelector((s) => s.exitFlow?.state);
  const targetUrl = targetForState(exitState, location.pathname);
  const isLocked = useSelector(selectIsExitLocked);
  const isGameplay = GAMEPLAY_PATH_REGEX.test(location.pathname);
  if (isLocked && isGameplay) {
    return <Navigate to={targetUrl} replace />;
  }

  // IMPORTANT: render Outlet so child routes show up
  return <Outlet />;
}
